module.exports = __webpack_public_path__ + "img/WorkflowIcon_active.bbd03c17.svg";